import Decimal from 'decimal.js'

function calculateSalesTax (amount, taxRate) {
  const tax = new Decimal(taxRate).div(100)
  return new Decimal(amount).mul(tax).round().toNumber()
}

export { calculateSalesTax }
